{
  "name": "react-native-worklets",
  "version": "0.13.0",
  "description": "The React Native multithreading library",
  "keywords": [
    "react-native",
    "react",
    "native",
    "worklets"
  ],
  "scripts": {
    "build": "yarn workspace babel-plugin-worklets build && yarn workspace worklets-oxc-plugin build && yarn set-version && yarn run --top-level bob build",
    "circular-dependency-check": "yarn madge --extensions js,jsx --circular lib",
    "find-unused-code:js": "knip",
    "format": "yarn format:js && yarn format:plugin && yarn format:common && yarn format:android && yarn format:apple",
    "format:android": "yarn format:android:java && yarn format:android:cpp && yarn format:android:cmake",
    "format:android:cpp": "find android/src -iname \"*.h\" -o -iname \"*.cpp\" | xargs clang-format -i",
    "format:android:cmake": "find ./android -type d \\( -name build -o -name .cxx \\) -prune -o -type f -name 'CMakeLists.txt' -print | xargs ../../scripts/format-cmake.sh",
    "format:android:java": "node ../../scripts/format-java.js",
    "format:apple": "find apple -iname \"*.h\" -o -iname \"*.m\" -o -iname \"*.mm\" -o -iname \"*.cpp\" | xargs clang-format -i",
    "format:common": "find Common -iname \"*.h\" -o -iname \"*.cpp\" | xargs clang-format -i",
    "format:js": "yarn run --top-level oxfmt src",
    "format:plugin": "yarn workspace babel-plugin-worklets format",
    "lint": "yarn lint:js && yarn lint:plugin && yarn lint:android && yarn lint:apple && yarn lint:clang-tidy",
    "lint:android": "../../scripts/validate-android.sh && ../../scripts/validate-common.sh && ./android/gradlew -p android spotlessCheck -q && yarn format:common --dry-run -Werror && yarn format:android:cpp --dry-run -Werror && yarn lint:cmake",
    "lint:apple": "../../scripts/validate-apple.sh && ../../scripts/validate-common.sh && yarn format:common --dry-run -Werror && yarn format:apple --dry-run -Werror",
    "lint:cmake": "find ./android -type d \\( -name build -o -name .cxx \\) -prune -o -type f -name 'CMakeLists.txt' -print | xargs ../../scripts/lint-cmake.sh",
    "lint:clang-tidy": "yarn lint:clang-tidy:ios && yarn lint:clang-tidy:android",
    "lint:clang-tidy:ios": "../../scripts/llvm-tools/clang-tidy-lint.sh --platform=ios",
    "lint:clang-tidy:android": "../../scripts/llvm-tools/clang-tidy-lint.sh --platform=android",
    "lint:js": "eslint src && yarn run --top-level oxfmt --check src && yarn validate-mock",
    "lint:plugin": "yarn workspace babel-plugin-worklets lint",
    "prepack": "yarn build",
    "set-version": "node scripts/set-version.js",
    "test": "yarn run --top-level jest",
    "type:check": "yarn type:check:src:native && yarn type:check:src:web && yarn type:check:plugin && yarn type:check:app && yarn type:check:tests",
    "type:check:src:native": "yarn tsc --noEmit",
    "type:check:src:web": "yarn tsc --noEmit --project tsconfig.web.json",
    "type:check:app": "yarn workspace common-app type:check",
    "type:check:plugin": "yarn workspace babel-plugin-worklets type:check",
    "type:check:tests": "../../scripts/test-ts.sh __typetests__",
    "type:check:legacy-rn-types": "yarn type:check:legacy-rn-types:src && yarn type:check:legacy-rn-types:app && yarn type:check:legacy-rn-types:tests",
    "type:check:legacy-rn-types:src": "yarn tsc --noEmit --customConditions react-native-legacy-deep-imports",
    "type:check:legacy-rn-types:app": "yarn workspace common-app type:check:legacy-rn-types",
    "type:check:legacy-rn-types:tests": "../../scripts/test-ts.sh --customConditions react-native-legacy-deep-imports __typetests__",
    "tree-shake:check:web": "yarn is-tree-shakable --resolution web",
    "validate-mock": "node --experimental-strip-types ../../scripts/validate-mock.mts --source src/index.ts --mock src/mock.ts --tsConfig tsconfig.native.json",
    "validate-peers": "node ../../scripts/validate-compatibility-peer-dependencies.js"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/software-mansion/react-native-reanimated.git",
    "directory": "packages/react-native-worklets"
  },
  "license": "MIT",
  "readmeFilename": "README.md",
  "bugs": {
    "url": "https://github.com/software-mansion/react-native-reanimated/issues"
  },
  "homepage": "https://docs.swmansion.com/react-native-worklets",
  "peerDependencies": {
    "@babel/core": "*",
    "@react-native/metro-config": "*",
    "react": "*",
    "react-native": "0.86 - 0.88"
  },
  "dependencies": {
    "@babel/generator": "^7.27.1",
    "@babel/plugin-transform-arrow-functions": "^7.27.1",
    "@babel/plugin-transform-class-properties": "^7.28.6",
    "@babel/plugin-transform-classes": "^7.28.6",
    "@babel/plugin-transform-nullish-coalescing-operator": "^7.28.6",
    "@babel/plugin-transform-optional-chaining": "^7.28.6",
    "@babel/plugin-transform-shorthand-properties": "^7.27.1",
    "@babel/plugin-transform-template-literals": "^7.27.1",
    "@babel/plugin-transform-unicode-regex": "^7.27.1",
    "@babel/preset-typescript": "^7.28.5",
    "@babel/traverse": "^7.27.1",
    "@babel/types": "^7.27.1",
    "@jridgewell/remapping": "^2.3.5",
    "convert-source-map": "^2.0.0",
    "semver": "^7.7.4",
    "whatwg-fetch": "^3.6.20"
  },
  "devDependencies": {
    "@babel/cli": "7.28.3",
    "@babel/core": "7.29.6",
    "@react-native-community/cli": "20.2.0",
    "@react-native/eslint-config": "0.88.0-rc.1",
    "@react-native/jest-preset": "0.88.0-rc.1",
    "@types/node": "24.7.0",
    "@types/react": "19.2.18",
    "clang-format-node": "1.3.5",
    "eslint": "9.37.0",
    "is-tree-shakable": "0.5.0",
    "knip": "5.61.3",
    "madge": "8.0.0",
    "react": "19.3.0",
    "react-native": "0.88.0-rc.1",
    "typescript": "5.9.3"
  },
  "main": "./lib/module/index",
  "module": "./lib/module/index",
  "react-native": "./src/index",
  "source": "./src/index",
  "types": "lib/typescript/index.d.ts",
  "files": [
    "src",
    "lib",
    "android",
    "apple",
    "Common",
    "compatibility.json",
    "bundleMode/index.js",
    "bundleMode/index.d.ts",
    "bundleMode/shims/*.js",
    "bundleMode/polyfills/*.js",
    "scripts/worklets_utils.rb",
    "scripts/validate-react-native-version.js",
    "jest",
    "plugin/index.js",
    "plugin/index.d.ts",
    "plugin-oxc/index.js",
    "plugin-oxc/index.d.ts",
    "plugin-oxc/babel.js",
    "plugin-oxc/babel.d.ts",
    "plugin-oxc/*.node",
    "Package.swift",
    "*.podspec",
    "react-native.config.js",
    "!apple/build",
    "!android/build",
    "!android/gradle",
    "!android/gradlew",
    "!android/gradlew.bat",
    "!android/local.properties",
    "!.worklets",
    ".worklets/dummy.md",
    "!**/__tests__",
    "!**/__fixtures__",
    "!**/__mocks__",
    "!**/.*"
  ],
  "sideEffects": [
    "./src/index.ts",
    "./lib/module/index.js",
    "./**/runtimeKind.{js,ts}",
    "./**/serializable.native.{js,ts}",
    "./**/initializers.native.{js,ts}",
    "./**/featureFlags.native.{js,ts}"
  ],
  "codegenConfig": {
    "name": "rnworklets",
    "type": "modules",
    "jsSrcsDir": "src/specs",
    "android": {
      "javaPackageName": "com.swmansion.worklets"
    },
    "ios": {
      "unstableModulesRequiringMainQueueSetup": [
        "WorkletsModule"
      ]
    }
  }
}
